import { render, staticRenderFns } from "./UsersPrivilegeMedicationPlan.vue?vue&type=template&id=0d16ad92&scoped=true&"
import script from "./UsersPrivilegeMedicationPlan.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeMedicationPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16ad92",
  null
  
)

export default component.exports